"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/modal/style/css");

var _modal = _interopRequireDefault(require("antd/es/modal"));

var _lodash = _interopRequireDefault(require("lodash"));

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _reactRedux = require("react-redux");

var _reactDraggable = _interopRequireDefault(require("react-draggable"));

var _UnsavedLeavingGuard = _interopRequireDefault(require("../util/UnsavedLeavingGuard"));

var selectors = _interopRequireWildcard(require("../../redux/selectors"));

require("./appointmentModal.scss");

var _AppointmentModalHeader = require("./AppointmentModalHeader");

var _reselect = require("reselect");

var _AvailabilityForm = _interopRequireDefault(require("./AvailabilityForm"));

var _availability = require("../../redux/availabilty/availability.types");

var _moment = _interopRequireDefault(require("moment"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  confirm
} = _modal.default;
const defaultState = {
  isUnsaved: false,
  disableDrag: true
};

class AvailabilityModal extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = _lodash.default.clone(defaultState);
    this.form = /*#__PURE__*/_react.default.createRef();

    this.handleSave = async () => {
      const {
        studyId,
        history
      } = this.props;

      if (this.form.current) {
        try {
          const values = await this.form.current.validateFields();
          const {
            userId,
            startDate,
            startTime,
            endTime
          } = values;
          const newAvailability = {
            userId,
            startDate: (0, _moment.default)(`${startDate.format('YYYY-MM-DD')} ${startTime.format('hh:mm A')}`, 'YYYY-MM-DD hh:mm A').toDate(),
            endDate: (0, _moment.default)(`${startDate.format('YYYY-MM-DD')} ${endTime.format('hh:mm A')}`, 'YYYY-MM-DD hh:mm A').toDate()
          };
          this.props.saveAvailability(newAvailability);
          this.setIsUnsaved(false);
          history.push(`/study/${studyId}/appointments/availability`);
        } catch (err) {
          console.log(err);
        }
      }
    };

    this.handleCancel = () => {
      const {
        history,
        studyId,
        removeEvent,
        newOrEdit
      } = this.props;

      if (newOrEdit === 'new' && removeEvent) {
        removeEvent();
      }

      history.push(`/study/${studyId}/appointments/availability`);
    };

    this.handleRemove = () => {
      const {
        studyId,
        selectedAvailability,
        newOrEdit,
        deleteAvailability,
        history,
        removeEvent
      } = this.props;

      if (selectedAvailability) {
        if (newOrEdit === 'new' && removeEvent) {
          removeEvent();
        } else {
          confirm({
            title: 'Are you sure you want to remove this availability?',
            okText: 'Remove',
            okType: 'danger',
            onOk: () => {
              deleteAvailability(selectedAvailability.id);
              this.resetState();
              history.push(`/study/${studyId}/appointments/availability`);

              if (removeEvent) {
                removeEvent();
              }
            },

            onCancel() {}

          });
        }
      }
    };

    this.setIsUnsaved = isUnsaved => {
      this.setState({
        isUnsaved
      });
    };

    this.resetState = () => {
      this.setState(_lodash.default.clone(defaultState));
    };

    this.onChange = () => {
      this.setState({
        isUnsaved: true
      });
    };

    this.onMouseOverHeader = () => {
      if (this.state.disableDrag) {
        this.setState({
          disableDrag: false
        });
      }
    };

    this.onMouseOutHeader = () => {
      if (!this.state.disableDrag) {
        this.setState({
          disableDrag: true
        });
      }
    };
  }

  render() {
    const {
      isUnsaved,
      disableDrag
    } = this.state;
    const {
      newOrEdit,
      requestedAvailabilityTab,
      selectedAvailability
    } = this.props;
    const showModal = !!(newOrEdit && requestedAvailabilityTab === 'availability');
    return /*#__PURE__*/_react.default.createElement(_modal.default, {
      title: /*#__PURE__*/_react.default.createElement(_AppointmentModalHeader.AppointmentModalHeader, {
        editing: !!newOrEdit,
        showRemove: newOrEdit === 'edit',
        showSave: newOrEdit === 'new' || isUnsaved,
        editClick: () => {},
        removeClick: this.handleRemove,
        closeClick: this.handleCancel,
        saveClick: this.handleSave,
        onMouseOver: this.onMouseOverHeader,
        onMouseOut: this.onMouseOutHeader
      }),
      visible: showModal,
      onOk: this.handleSave,
      onCancel: this.handleCancel,
      footer: null,
      closable: false,
      mask: false,
      destroyOnClose: true,
      afterClose: () => this.resetState(),
      modalRender: modal => /*#__PURE__*/_react.default.createElement(_reactDraggable.default, {
        disabled: disableDrag
      }, modal)
    }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_UnsavedLeavingGuard.default, {
      when: isUnsaved,
      navigate: path => {
        this.props.history.push(path);
      },
      shouldBlockNavigation: () => isUnsaved
    }), /*#__PURE__*/_react.default.createElement(_AvailabilityForm.default, {
      formRef: this.form,
      availability: selectedAvailability,
      onChange: this.onChange,
      disabled: newOrEdit !== 'new'
    })));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  studyId: selectors.getRequestedStudyId,
  requestedAvailabilityTab: selectors.getUrlRouteSubpage,
  newOrEdit: selectors.getUrlRouteNewOrEdit
});

const mapDispatchToProps = dispatch => {
  return {
    deleteAvailability: id => dispatch(_availability.deleteAvailabilityAsync.request(id))
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouterDom.withRouter)(AvailabilityModal));

exports.default = _default;